import React from 'react';
import { Button as UiButton } from '../../ui/Button';

const ActionButtonsSection = ({
    isSubmitting,
    handleSubmit,
    resetForm,
    isDark
}) => {
    return (
        <div className='w-full max-w-[822px] pt-[20px]'>
            <div className='flex flex-col sm:flex-row justify-start gap-[16px] sm:gap-[12px]'>
                <UiButton
                    variant="ghost"
                    className={`text-[16px] px-[16px] py-[12px] rounded-[12px] transition-colors duration-200 ${isSubmitting ? 'opacity-50' : ''} ${
                        isDark
                            ? 'bg-[#cd6d2c] text-[#000000] hover:bg-[#ffffff]'
                            : 'bg-[#cd6d2c] text-white hover:bg-[#072837]'
                    }`}
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                >
                    {isSubmitting ? 'Submitting...' : 'Submit Form'}
                </UiButton>
                <UiButton
                    variant="ghost"
                    className={`text-[16px] px-[16px] py-[12px] rounded-[12px] transition-colors duration-200 ${isSubmitting ? 'opacity-50' : ''} ${
                        isDark
                            ? 'bg-[#000000] text-[#ffffff] hover:bg-[#1a1a1a]'
                            : 'bg-[#D9D9D9] text-[#072837] hover:bg-[#D9D9D9]'
                    }`}
                    onClick={resetForm}
                >
                    Reset Fields
                </UiButton>
            </div>
        </div>
    );
};

export default ActionButtonsSection;
